import axiosApiInstance from 'axios'
export default axiosApiInstance;